<div class="release-container">
  <!-- Header -->
  <header class="release-header">
    <div class="header-container">
      <a class="logo" routerLink="/" aria-label="LOQT home">
        <img src="/assets/icons/Loqt_Logotype-06.svg" alt="LOQT" class="logo-image">
      </a>
      <nav class="nav-actions">
        <button mat-button (click)="navigateToHome()" class="back-btn">
          <mat-icon>arrow_back</mat-icon>
          Back to home
        </button>
        <button mat-flat-button (click)="navigateToSignup()" class="signup-btn">Create School Account</button>
      </nav>
    </div>
  </header>

  <!-- Page intro -->
  <section class="page-intro">
    <div class="intro-content">
      <span class="page-eyebrow">Product updates</span>
      <h1 class="page-title">What's new in LOQT</h1>
      <p class="page-lead">
        Every release, in plain language. This is what has changed for schools, parents and students.
      </p>
    </div>
  </section>

  <!-- Latest release -->
  <section class="latest-section" *ngIf="latest">
    <article class="release-card featured" [attr.id]="latest.id">
      <div class="release-meta">
        <span class="release-badge">Latest release</span>
        <time class="release-date" [attr.datetime]="latest.releasedOn">
          Released {{ latest.releasedOn | date: 'dd/MM/yyyy' }}
        </time>
      </div>
      <h2 class="release-title">{{ latest.title }}</h2>
      <p class="release-summary">{{ latest.summary }}</p>

      <div class="release-sections">
        <section class="release-section" *ngFor="let section of latest.sections">
          <h3>{{ section.title }}</h3>
          <ul>
            <li *ngFor="let item of section.items">
              <strong *ngIf="item.lead">{{ item.lead }}</strong>
              {{ item.text }}
            </li>
          </ul>
        </section>
      </div>
    </article>
  </section>

  <!-- History -->
  <section class="history-section">
    <div class="section-head">
      <span class="section-eyebrow">Archive</span>
      <h2 class="section-title">Release history</h2>
      <p class="section-lead">Everything we have published before, newest first.</p>
    </div>

    <div class="history-list" *ngIf="history.length; else noHistory">
      <mat-accordion class="history-accordion" multi>
        <mat-expansion-panel *ngFor="let note of history; trackBy: trackById" [attr.id]="note.id">
          <mat-expansion-panel-header>
            <mat-panel-title>{{ note.title }}</mat-panel-title>
            <mat-panel-description>Released {{ note.releasedOn | date: 'dd/MM/yyyy' }}</mat-panel-description>
          </mat-expansion-panel-header>

          <p class="release-summary">{{ note.summary }}</p>
          <div class="release-sections">
            <section class="release-section" *ngFor="let section of note.sections">
              <h3>{{ section.title }}</h3>
              <ul>
                <li *ngFor="let item of section.items">
                  <strong *ngIf="item.lead">{{ item.lead }}</strong>
                  {{ item.text }}
                </li>
              </ul>
            </section>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <ng-template #noHistory>
      <p class="history-empty">
        This is our first published release note. Earlier releases will appear here as they are published.
      </p>
    </ng-template>
  </section>

  <!-- Footer -->
  <footer class="release-footer">
    <div class="footer-content">
      <div class="footer-brand">
        <img src="/assets/icons/Loqt_Logotype-06.svg" alt="LOQT" class="footer-logo-image">
        <p>Less screen. More time.</p>
      </div>
      <div class="footer-links">
        <a routerLink="/">Home</a>
        <a href="https://loqt.app/contact" target="_blank" rel="noopener">Contact</a>
        <a href="https://loqt.app/privacy-policy" target="_blank" rel="noopener">Privacy</a>
      </div>
    </div>
  </footer>
</div>
